import React from 'react'
import { Navbar, Footer } from "../../components"
import { SolarCreateAccount } from "../SolarSignUp"
export default function SignUp() {
  return (
    <div className='emas__signup'>
        <Navbar />
        <SolarCreateAccount />
        <Footer />
    </div>
  )
}
